<template>
  <div
    :class="{ 'c-loading': true, 'c-loading--small': small, 'c-loading--inline': inline, 'c-loading--overlay': overlay }"
  >
    <div :class="{ 'c-loading__icon': true, 'c-loading__icon--white': white }">
      <i class="fa fa-repeat" />
    </div>
  </div>
</template>

<script>
/**
 * Komponente zur Darstellung eines Loadingspinners
 * @displayName BaseLoading
 */
export default {
  name: 'BaseLoading',
  props: {
    small: {
      type: Boolean,
      default: false
    },
    inline: {
      type: Boolean,
      default: false
    },
    white: {
      type: Boolean,
      default: false
    },
    overlay: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="less">
.c-loading {
  align-content: center;
  align-items: center;
  display: flex;
  height: 100%;
  min-height: 400px;
  justify-content: center;
  width: 100%;

  &--small {
    height: auto;
    justify-content: flex-start;
    width: auto;

    .c-loading__icon {
      font-size: 1.25rem !important;
    }
  }

  &--inline {
    display: inline-block;
    height: auto;
    width: auto;
    min-height: unset;

    .c-loading__icon {
      display: inline-block;
    }
  }

  &--overlay {
    position: sticky;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 9999;

    .c-loading__icon {
      font-size: 6rem;
    }
  }

  &__icon {
    color: #007fb4;
    font-size: 2rem;

    i {
      animation-duration: 1000ms;
      animation-iteration-count: infinite;
      animation-name: spin;
      animation-timing-function: linear;
      display: block;
    }

    &--white {
      color: #fff !important;
    }
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
